import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  getAllPageSuccess,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error,
  getAllPage,
} from './actions';

import { ServiceEquipamento } from '~/services/modulos/serviceEquipamento';
import { createSagaReutils, createAllTakeLastDefault } from '~/utils/reutils';
import ACTION from '../actionTypes';

const ACOES_DEFULT = createSagaReutils(
  `/equipamentos`,
  ServiceEquipamento,
  getAllPage,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error
);

function* listPageableSaga({ params }) {
  try {
    const list = yield call(ServiceEquipamento.getAllPageable, params);
    yield put(getAllPageSuccess(list));
  } catch (e) {
    yield put(error(e));
  }
}

export default all([
  ...createAllTakeLastDefault({ modulo: 'equipamento', ACOES: ACOES_DEFULT }),
  takeLatest(ACTION.EQUIPAMENTO_GET_SEARCH_PAGE, listPageableSaga),
]);
